module.exports = __webpack_public_path__ + "img/b2-2.c491912.png";